<template>
    <div class="category">
        <figure>
            <template v-if="data.icon">
                <img :src="data.icon"
                     loading="lazy"
                     :alt="data.name"
                >
            </template>
            <template v-else>
                <img :src="defaultImage"
                     loading="lazy"
                     :alt="data.name"
                >
            </template>
        </figure>

        <div class="main-link">
            <a :href="data.value" class="category-name js-ga-event"
               data-page-area="sub_menu"
               data-type="item"
               data-name="subcategory-name"
               :data-text="data.name"
               data-action="href"
               :data-destination-url="data.value"
            >
                {{ data.name }}
                <img src="/img/icons/menu-arrow.svg" alt="" v-if="clientWidth >= 991">
            </a>
            <span class="arrow"
                  v-if="clientWidth < 991"
                  @click="handleClick"
                  :class="{ rotate: subcategoriesVisible }"
            >
                 <img src="/img/icons/menu-arrow.svg" alt="">
            </span>
        </div>

        <ul v-if="data.children.length"
            :class="{ visible: subcategoriesVisible }"
        >
            <li v-for="(item, key) in data.children"
                :key="key">
                <a :href="item.value"
                   class="js-ga-event"
                   data-page-area="sub_menu"
                   data-type="item"
                   data-name="subcategory-name"
                   :data-text="item.name"
                   data-action="href"
                   :data-destination-url="item.value"
                >
                    {{ item.name }}
                </a>
            </li>
        </ul>

        <a :href="data.value"
           class="all js-ga-event"
           v-if="data.children.length > 4"
           :class="{ visible: subcategoriesVisible }"
           data-page-area="sub_menu"
           data-type="item"
           data-name="subcategory-name"
           :data-text="data.name"
           data-action="href"
           :data-destination-url="data.value"
        >
            {{ allText }}
        </a>
    </div>
</template>

<script>
import { inject, ref, toRefs } from 'vue'

export default {

    props: [
        'data',
        'allText'
    ],

    setup() {

        const constants = inject('constants')
        const subcategoriesVisible = ref(false)

        function handleClick() {
            subcategoriesVisible.value = !subcategoriesVisible.value
        }

        return {
            ...toRefs(constants),
            subcategoriesVisible,
            handleClick
        }
    }
}
</script>
